import { useState } from "react";
import { fmtDate } from "@/lib/api";
import { Badge, Empty } from "@/components/common";

const STAGES = [["hot", "Hot - needs a reply", "text-[#FF6B35]"], ["meeting", "Meeting booked", "text-emerald-400"], ["waiting", "Waiting on them", "text-zinc-400"]];

const Item = ({ t, sel, onSelect, sub }) => (
  <button data-testid={`thread-item-${t.id}`} onClick={() => onSelect(t.id)} className={`w-full text-left px-4 py-3 border-b border-border/60 transition-colors ${sel === t.id ? "bg-[#1A1A1A]" : "hover:bg-[#121212]"}`}>
    <div className="flex items-center gap-2"><span className="font-medium text-sm truncate">{t.contact.name || t.contact.email}</span>{t.manual_takeover && <Badge v="human" tone="amber" />}<span className="ml-auto text-[10px] font-mono text-zinc-500">{fmtDate(t.last_at)}</span></div>
    <div className="text-xs text-zinc-500 truncate">{t.contact.company}</div>
    <div className="text-xs text-zinc-400 truncate mt-1">{sub || `${t.last?.direction === "in" ? "← " : "→ "}${t.last?.body?.slice(0, 60) || ""}`}</div>
  </button>
);

const Tab = ({ id, label, n, on, set }) => (
  <button data-testid={`inbox-tab-${id}`} onClick={() => set(id)} className={`flex-1 py-2.5 text-xs font-semibold uppercase tracking-wider border-b-2 transition-colors ${on ? "border-[#007AFF] text-white" : "border-transparent text-zinc-500 hover:text-zinc-300"}`}>
    {label} <span className="font-mono text-zinc-500">{n}</span>
  </button>
);

export const InboxList = ({ data, sel, onSelect }) => {
  const [tab, setTab] = useState("prospect");
  const prospects = (data || []).filter((t) => t.view === "prospect");
  const handled = (data || []).filter((t) => t.view === "handled");
  return (
    <div className="border-r border-border overflow-y-auto" data-testid="thread-list">
      <div className="flex sticky top-0 bg-[#0A0A0A] z-10 border-b border-border">
        <Tab id="prospect" label="Prospects" n={prospects.length} on={tab === "prospect"} set={setTab} />
        <Tab id="handled" label="Handled by MaSa" n={handled.length} on={tab === "handled"} set={setTab} />
      </div>
      {tab === "prospect" ? (
        !prospects.length ? <div className="p-4"><Empty>No prospects waiting on you.</Empty></div> : STAGES.map(([k, label, tone]) => {
          const rows = prospects.filter((t) => t.stage === k);
          return rows.length ? (
            <div key={k} data-testid={`inbox-stage-${k}`}>
              <div className={`px-4 py-2 text-[11px] uppercase tracking-wider font-semibold ${tone} bg-[#0F0F0F]`}>{label} · {rows.length}</div>
              {rows.map((t) => <Item key={t.id} t={t} sel={sel} onSelect={onSelect} />)}
            </div>
          ) : null;
        })
      ) : (
        <div data-testid="inbox-handled-list">
          <p className="px-4 py-2 text-[11px] text-zinc-500">MaSa has already dealt with these. Nothing to do unless one was sorted wrongly.</p>
          {!handled.length ? <div className="p-4"><Empty>Nothing here yet.</Empty></div> : handled.map((t) => <Item key={t.id} t={t} sel={sel} onSelect={onSelect} sub={t.stage} />)}
        </div>
      )}
    </div>
  );
};
